module.exports = __webpack_public_path__ + "095a98235efea56868d6d45a7ba84d87.svg";